// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.locations.RentalManagerUserPropertyLocationRestrictionsWebApiHandler

import type { QueryOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserPropertyLocationRestrictionsWebApiHandler_restrictions,
  RentalManagerUserPropertyLocationRestrictionsWebApiHandler_restrictions_Path,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  ListingAlias,
  ListingType,
  PropertyType,
  UserPropertyLocationRestrictionsResponseWebDto,
} from '@zg-rentals/ts-rental-manager-api-client';

interface RestrictionsParams {
  fullAddress: string;
  listingAlias?: ListingAlias;
  listingType: ListingType;
  propertyType?: PropertyType;
  unit?: string;
}

export type RentalManagerUserPropertyLocationRestrictionsWebApiHandler_restrictions_Options = UseQueryOptions<
  UserPropertyLocationRestrictionsResponseWebDto,
  unknown,
  UserPropertyLocationRestrictionsResponseWebDto,
  readonly [string, RestrictionsParams]
>;

const RentalManagerUserPropertyLocationRestrictionsWebApiHandler_restrictions_GetKey = (
  getParams: RestrictionsParams,
) => [RentalManagerUserPropertyLocationRestrictionsWebApiHandler_restrictions_Path, getParams] as const;

export const RentalManagerUserPropertyLocationRestrictionsWebApiHandler_restrictions_queryOptions = (
  getParams: RestrictionsParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserPropertyLocationRestrictionsWebApiHandler_restrictions_GetKey(getParams),
    queryFn: () => RentalManagerUserPropertyLocationRestrictionsWebApiHandler_restrictions(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get location restrictions for a property by address and listing type
 */
export const useRentalManagerUserPropertyLocationRestrictionsWebApiHandler_restrictions = (
  getParams: RestrictionsParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserPropertyLocationRestrictionsWebApiHandler_restrictions_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserPropertyLocationRestrictionsWebApiHandler_restrictions_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserPropertyLocationRestrictionsWebApiHandler_restrictions.getKey =
  RentalManagerUserPropertyLocationRestrictionsWebApiHandler_restrictions_GetKey;
